import React from 'react';
import {
  ExtensionSlot,
} from 'piral-core';

// Helper function to render multiple extension slots for a region
const renderSlots = (regionName, props, maxSlots = 10) => {
  const slots = [];

  // Render base slot (e.g., "sidebar")
  slots.push(<ExtensionSlot key={regionName} name={regionName} params={props} />);

  // Render numbered slots (e.g., "sidebar-1", "sidebar-2", etc.)
  for (let i = 1; i <= maxSlots; i++) {
    slots.push(<ExtensionSlot key={`${regionName}-${i}`} name={`${regionName}-${i}`} params={props} />);
  }

  return slots;
};

/**
 * Sidebar Layout Component
 * 
 * This layout provides a sidebar and main content area.
 * The sidebar can be positioned on the left or right (default: left).
 * 
 * AVAILABLE EXTENSION SLOTS:
 * - "sidebar": Left/right sidebar (250px wide)
 * - "main": Main content area (takes remaining space)
 * - Numbered variants: "sidebar-1", "sidebar-2", "main-1", "main-2", etc.
 * 
 * USE CASE:
 * - Documentation sites
 * - Admin panels
 * - Settings pages
 * - Application with navigation sidebar
 * 
 * CONFIGURATION:
 * The sidebar appears on the left by default. To change the position or width,
 * modify the gridTemplateColumns and gridTemplateAreas in the style.
 * 
 */
export default {
  Layout: (props) => {
    const { pageKey, ...otherProps } = props;
    const prefix = `${pageKey || ''}-`;
    
    return (
      <div style={{
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
        display: 'grid',
        gridTemplateAreas: '"sidebar main"',
        gridTemplateColumns: '250px 1fr',
        height: '100vh',
        width: '100vw',
        overflow: 'hidden'
      }}>
        <div style={{
          gridArea: 'sidebar',
          padding: '20px',
          overflowY: 'auto',
          backgroundColor: '#f5f5f5'
        }}>
          {renderSlots(`${prefix}sidebar`, otherProps)}
        </div>

        <div style={{
          gridArea: 'main',
          padding: '20px',
          overflowY: 'auto',
          backgroundColor: '#ffffff'
        }}>
          {renderSlots(`${prefix}main`, otherProps)}
        </div>
      </div>
    );
  },
}
